import { useAppSelector } from 'hooks/reduxHooks'
import useOfferListKey from './useOfferListKey'

export interface Options {
  disabled?: boolean
}

function useStreamEnded(
  filters: App.OfferListFilters | undefined,
  options: Options = {},
): boolean {
  const disabled = options.disabled || !filters

  const listKey = useOfferListKey(filters)

  const streamEnd = useAppSelector(state => state.offer.offerLists[listKey]?.streamEnded) ?? false

  if (disabled) {
    return false
  }

  return streamEnd
}

export default useStreamEnded
